module.exports = __webpack_public_path__ + "img/244.908b0833.jpg";